import { render, staticRenderFns } from "./userInventions.vue?vue&type=template&id=51c79936&scoped=true"
import script from "./userInventions.vue?vue&type=script&lang=js"
export * from "./userInventions.vue?vue&type=script&lang=js"
import style0 from "./userInventions.vue?vue&type=style&index=0&id=51c79936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c79936",
  null
  
)

export default component.exports